import { inject, Service } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { User } from "@/shared-module/models";
import { Userpilot } from "userpilot";

@Service()
export class AuthenticationService {
  private http = inject(HttpClient);

  currentUser: User;
  static userPilotInitialized: boolean = false;

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
  }

  public get currentUserValue(): User {
    if (
      this.currentUser != null &&
      !AuthenticationService.userPilotInitialized
    ) {
      Userpilot.identify(this.currentUser.userName, {
        name: this.currentUser.userName,
        locale_code: this.currentUser.language /*,
                email: user.email,
                created_at: user.created_at,*/,
      });
      console.log(
        `UserPilot initialized with username ${this.currentUser.userName}`,
      );
      AuthenticationService.userPilotInitialized = true;
    }

    return this.currentUser;
  }

  login(username, password) {
    this.startSession();
    return this.http.post<User>("api/login", { username, password }).pipe(
      map((reply) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (reply.isSuccess) {
          localStorage.setItem("currentUser", JSON.stringify(reply));
          this.currentUser = reply;
        }
        return reply;
      }),
    );
  }

  connect(idToken) {
    this.startSession();
    return this.http.post<User>("api/login", { idToken }).pipe(
      map((reply) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (reply.isSuccess) {
          localStorage.setItem("currentUser", JSON.stringify(reply));
          this.currentUser = reply;
        }
        return reply;
      }),
    );
  }

  /**
   * A login starts a new session, and the id has to exist BEFORE the request
   * goes out: the jwt interceptor puts it in X-Session-Id, and the server opens
   * the session row under whatever id that header carries. Minting it after the
   * reply would leave the server tracking an id the client no longer uses.
   */
  private startSession() {
    localStorage.setItem("sessionId", crypto.randomUUID());
    localStorage.setItem("lastActivityAt", String(Date.now()));
  }

  logout() {
    // The guard and the 401 interceptor also call this with no session to
    // sign out of; an anonymous signout is itself a 401, which the
    // interceptor answers with another logout() and a location.reload().
    if (this.currentUser?.token) {
      this.http.post("api/signout", {}).subscribe({ error: () => {} });
    }
    localStorage.removeItem("currentUser");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("lastActivityAt");
    this.currentUser = null;
    AuthenticationService.userPilotInitialized = false;
  }
}
